import Spinner from 'components/Spinner/Spinner'
import {
  OauthPlatform,
  Platform,
  useAddMediaAccountMutation,
  useGetOauthTokensQuery,
} from 'graphql/generated/graphql'
import { usePageNavigation } from 'hooks/useNavigation'
import React, { useEffect, useRef } from 'react'
import { useSearchParams } from 'react-router-dom'

export default function YouTube(): JSX.Element {
  const [searchParams] = useSearchParams()
  const code = searchParams.get('code')
  const { navigateToDashboard } = usePageNavigation()
  const firstTime = useRef(true)
  const [addMediaAccount, { loading: addMediaLoading }] =
    useAddMediaAccountMutation()

  const { loading, data } = useGetOauthTokensQuery({
    variables: {
      code: code ?? '',
      platform: OauthPlatform.Youtube,
    },
    skip: !code,
  })

  useEffect(() => {
    if (data?.oauth?.accessToken && firstTime.current) {
      firstTime.current = false
      localStorage.setItem('google_access_token', data.oauth.accessToken)

      console.log('About to call addMediaAccount with:', {
        accessToken: !!data.oauth.accessToken,
        platform: Platform.Youtube,
        refreshToken: !!data.oauth.refreshToken,
      })

      addMediaAccount({
        variables: {
          accessToken: data.oauth.accessToken,
          platform: Platform.Youtube,
          refreshToken: data.oauth.refreshToken,
        },
      })
        .then((result) => {
          console.log('addMediaAccount result:', result)
          navigateToDashboard()
        })
        .catch((e) => console.error('YouTube connect failed:', e))
    }
  }, [data, addMediaAccount, navigateToDashboard])

  if (!code) return <>Missing Code</>
  if (loading || addMediaLoading) return <Spinner />
  if (!data) return <>Something went wrong</>

  return <>Successful</>
}
